import { NgIf } from '@angular/common';
import { Component, ViewChild, TemplateRef, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { CartLine } from '@next/core-lib/cart';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';
import { LocaleService } from '@next/core-lib/i18n';

@Component({
  templateUrl: './column-delivery-period.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgIf, AgrI18nSharedModule],
})
export class ColumnDeliveryPeriodComponent implements AfterViewInit {
  @ViewChild('template') template: TemplateRef<unknown>;
  public initCallback: () => void;

  constructor(private readonly locale: LocaleService) {}
  ngAfterViewInit() {
    this.initCallback?.();
  }

  hasPeriodId(row: CartLine): boolean {
    return row?.deliveryInformation?.periodId != null;
  }

  getSalesOrderPeriodName(row: CartLine): string {
    const periodName = row?.deliveryInformation?.deliverySalesOrderPeriod?.name || '';
    const shipType = row?.deliveryInformation?.shipType;

    if (periodName && shipType) {
      const shipTypeLabel = this.getShipTypeLabel(shipType);
      return `${periodName} - ${shipTypeLabel}`;
    }

    return periodName;
  }

  private getShipTypeLabel(shipType: string): string {
    const shipTypeMap: Record<string, string> = {
      Y1: this.locale.translate('delivery-preference.early'),
      Y2: this.locale.translate('delivery-preference.middle'),
      Y3: this.locale.translate('delivery-preference.late'),
    };
    return shipTypeMap[shipType] || shipType;
  }

  getPeriodStartDate(row: CartLine): Date | null {
    return row?.deliveryInformation?.deliverySalesOrderPeriod?.dateFrom;
  }

  getPeriodEndDate(row: CartLine): Date | null {
    return row?.deliveryInformation?.deliverySalesOrderPeriod?.dateTo;
  }
}
